import { Injectable, computed, signal } from '@angular/core';

@Injectable({ providedIn: 'root' })
export class SubmitStateService {
  private readonly pendingByKey = signal<Record<string, boolean>>({});

  isPending(key: string): boolean {
    return this.pendingByKey()[key] ?? false;
  }

  pendingSignal(key: () => string) {
    return computed(() => this.isPending(key()));
  }

  setPending(key: string, isPending: boolean): void {
    this.pendingByKey.update((state) => ({
      ...state,
      [key]: isPending,
    }));
  }

  clear(key: string): void {
    this.pendingByKey.update((state) => {
      if (!(key in state)) return state;
      const { [key]: _removed, ...next } = state;
      return next;
    });
  }
}
